import React from 'react';
import PayoutMgmt from '../../screens/PayoutMgmt';

const PayoutTeacherMgmt = () => {
    return <PayoutMgmt />
}

export default PayoutTeacherMgmt;